import styled from 'styled-components'

export const CardStyle = styled.div`
  display: none;

  @media screen and (max-width: 720px) {
    display: flex;
    flex-direction: column;
    div {
      padding: 5px;
      margin: 5px;
      border-radius: ${({ theme }) => {
        return theme.borderRadius.normal
      }};
      border: ${({ theme }) => {
        return theme.border
      }};
      font-size: ${({ theme }) => {
        return theme.fonts.size.normal
      }};
      font-weight: ${({ theme }) => {
        return theme.fonts.weight.thin
      }};
      background-color: ${({ theme }) => {
        return theme.colors.white
      }};

      li {
        margin: 0 0 0 16px;
      }
    }
  }
`
